import { render, staticRenderFns } from "./help_page_link.vue?vue&type=template&id=dddacccc"
import script from "./help_page_link.vue?vue&type=script&lang=js"
export * from "./help_page_link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports